export default __webpack_public_path__ + "static/media/amazon-connect.101f312b.svg";